export * from './tenancy-email/tenancy-email.component';
